const CashFlow = {

    // Janela de "a vencer" usada pelo aviso fixo no topo do sistema e pelo cartão da tela
    // de contas a pagar e receber. Os dois precisam contar os mesmos dias, senão o número
    // do aviso não bate com o da tela que ele manda abrir.
    DUE_SOON_DAYS: 7
}

// Último dia da janela de "a vencer", contado a partir de hoje.
export const getDueSoonLimitDate = () => {
    const limit = new Date();
    limit.setDate(limit.getDate() + CashFlow.DUE_SOON_DAYS);
    return limit;
}

export default CashFlow;
